'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var baseAccordion = require('../base/base-accordion.js');
var standardAccordions_module = require('./styles/standard-accordions.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Standard accordions
 * @param {StandardAccordionProps} props StandardAccordionProps
 */ const StandardAccordion = (props)=>{
    const accordions = props.accordions.map((accordion)=>{
        const { buttonIcon , buttonProps  } = accordion;
        return {
            ...accordion,
            buttonIcon: buttonIcon || /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
                className: standardAccordions_module.icon,
                icon: fontIcon$1.FontIcons.CaretDown,
                iconSize: 10
            }),
            buttonProps: {
                ...buttonProps,
                className: classnames__default.default(standardAccordions_module.accordionButton, buttonProps?.className)
            }
        };
    });
    return /*#__PURE__*/ React__default.default.createElement(baseAccordion.BaseAccordion, _extends({}, props, {
        accordions: accordions
    }));
};

exports.StandardAccordion = StandardAccordion;
//# sourceMappingURL=standard-accordion.js.map
